import { PERSONAL_EMAIL_DOMAINS } from './constants'

// Work-email gate. Recruiters must register with a corporate domain — personal
// inboxes are rejected with a friendly inline message (a real product rule:
// the company domain is what we attribute the recruiter's seat to).

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export interface EmailCheck {
  valid: boolean
  domain: string
  /** Set when the address is syntactically fine but not a work address. */
  reason?: string
}

export function checkWorkEmail(raw: string): EmailCheck {
  const email = raw.trim().toLowerCase()
  if (!email) return { valid: false, domain: '', reason: '' }
  if (!EMAIL_RE.test(email)) {
    return { valid: false, domain: '', reason: 'That doesn’t look like a valid email address.' }
  }
  const domain = email.split('@')[1]
  if (PERSONAL_EMAIL_DOMAINS.has(domain)) {
    return {
      valid: false,
      domain,
      reason: `Please use your work email — ${domain} is a personal inbox. Recruiters verify with a company domain.`,
    }
  }
  return { valid: true, domain }
}

/** "northwind.io" → "Northwind" — a friendly company name guess. */
export function companyFromDomain(domain: string): string {
  if (!domain) return ''
  const core = domain.split('.')[0]
  return core
    .split(/[-_]/)
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join(' ')
}
